import { useMemo } from "react"
import { useParams } from "react-router-dom"
import dayjs from "dayjs"
import { isEmpty } from "lodash"

import { useMovie } from "extensions/movie-show-time/hooks/useMovie"
import { ITheater } from "../interfaces"

interface IUseMovieDetailPageResult {
  movieId: string
  cinemaCode: string
}

type UseMovieDetailPage = () => IUseMovieDetailPageResult

// Add buffer duration to allow recently started showtime
const DURATION_BUFFER = 10 // minute

export const useMovieDetailPage: UseMovieDetailPage = () => {
  const { movieId, cinemaCode } = useParams()
  const { movie, isLoading } = useMovie(movieId, cinemaCode, {
    enabled: !!(movieId && cinemaCode),
  })
  const { theaters = [] } = movie || {}
  const currentTime = useMemo(() => dayjs(), [])
  // Filter only the showtime in the future
  const showingTheaters: ITheater[] = useMemo(
    () =>
      theaters
        .map((theater) => {
          const showtime = theater.showtime.filter((time) => {
            const [hour, minute] = time.split(":")
            const showingTime = dayjs()
              .set("hour", +hour)
              .set("minute", +minute + DURATION_BUFFER)
            const timeInFuture = showingTime.isSameOrAfter(currentTime)
            return timeInFuture
          })
          return { ...theater, showtime }
        })
        .filter((theater) => !isEmpty(theater.showtime)),
    [currentTime, theaters]
  )

  return {
    movieId,
    cinemaCode,
    isLoading,
    movie: { ...movie, theaters: showingTheaters || [] },
  }
}
